import type { OperationsMessages } from "./messages.en";
export const operationsEs: Record<keyof OperationsMessages, string> = {
  "pos.exit.method": "Método de aprobación",
  "pos.exit.scanQr": "Escanear QR con el teléfono",
  "pos.exit.usePassword": "Usar contraseña",
  "pos.exit.scanHint": "Escanee con la cámara de su teléfono. Un gerente del club o administrador de la plataforma puede aprobar la salida.",
  "pos.exit.qrTitle": "Escanear para aprobar la salida del POS",
  "pos.exit.matchCode": "Compare este código",
  "pos.exit.expires": "Válido por 2 minutos · una sola salida",
  "pos.exit.waiting": "Esperando aprobación en su teléfono…",
  "pos.exit.denied": "Salida rechazada. La pantalla POS sigue bloqueada.",
  "pos.exit.expired": "Este código QR ya no está activo. Solicite uno nuevo en el POS.",
  "pos.exit.newQr": "Obtener un nuevo código QR",
  "pos.exit.phoneTitle": "Aprobar salida del POS",
  "pos.exit.signedInAs": "Sesión de {name}",
  "pos.exit.invalidQr": "Este enlace QR no es válido. Escanee un código nuevo en la pantalla POS.",
  "pos.exit.confirmHint": "Compruebe que el club, la pantalla y el código de seis dígitos coincidan con el POS. La aprobación solo sale del modo POS en esa pantalla; no inicia su sesión en el terminal.",
  "pos.exit.deny": "Rechazar",
  "pos.exit.approve": "Aprobar esta salida",
  "pos.exit.approved": "Aprobado. La pantalla POS saldrá automáticamente. Puede cerrar esta página.",
  "pos.exit.accountHint": "Use su cuenta de ClubCore. Se muestra la cuenta de esta pantalla; cámbiela si aprueba otro gerente.",

  "pos.setup.command": "sudo ./install.sh",
  "pos.setup.repairDownload": "Solo descargar (reparar o actualizar)",
  "pos.setup.installedVersion": "Agente {version}",
  "pos.setup.title": "Instalar un agente de LAN",
  "pos.setup.intro": "Descárguelo en un PC/servidor Windows o dispositivo Linux del club que permanezca encendido. No necesita un servidor ClubCore local.",
  "pos.setup.step1": "Nombre el dispositivo y descargue el instalador.",
  "pos.setup.step2": "Ejecute el instalador como administrador y pegue el código de configuración.",
  "pos.setup.step3": "El agente se inicia al arrancar. Apruebe las impresoras descubiertas y asígnelas a puntos de venta o estaciones de cocina.",
  "pos.setup.platform": "Instalar en",
  "pos.setup.windows": "PC/servidor Windows (64 bits)",
  "pos.setup.linux": "Dispositivo Linux (systemd)",
  "pos.setup.downloadAndSetup": "Descargar instalador y código",
  "pos.setup.unavailable": "Este instalador no está disponible temporalmente. Contacte con su administrador.",
  "pos.setup.version": "Agente {version} · {size} MB",
  "pos.setup.codeHint": "Use este código en un dispositivo antes de {expires}. Solo se muestra aquí; manténgalo privado.",
  "pos.setup.code": "Código de configuración",
  "pos.setup.copy": "Copiar código",
  "pos.setup.copied": "Copiado",
  "pos.setup.downloadAgain": "Descargar de nuevo",
  "pos.setup.linuxCommand": "Extraiga la descarga de Linux y ejecute:",
  "pos.setup.statusHint": "Las impresoras informan a través del agente LAN. La actividad de los terminales se informa desde las pantallas de caja y cocina.",
  "pos.setup.checksum": "SHA-256 de la descarga",
  "pos.setup.manual": "Avanzado: credencial de agente manual",
  "pos.setup.pending": "Esperando instalación",
  "pos.setup.expired": "Código caducado",
  "pos.mode.lock": "Fijar en TPV",
  "pos.mode.unlock": "Salir del modo TPV",
  "pos.mode.managerHint":
    "Un gerente del club o administrador de la plataforma debe aprobar la salida. Escanee con su teléfono o use su contraseña de ClubCore.",
  "pos.mode.managerRequired":
    "Un gerente del club o administrador de la plataforma debe aprobar la salida del modo POS.",
  "apiError.pos_manager_required":
    "Un gerente del club o administrador de la plataforma debe aprobar la salida del modo POS.",
  "pos.nav.kitchen": "Cocina",
  "pos.nav.devices": "Dispositivos e impresión",
  "pos.ops.originalTicket": "Datos originales del pedido",
  "pos.ops.notRecorded": "Sin registrar",
  "pos.ops.server": "Mesero: {server}",
  "pos.ops.unassigned": "Sin asignar",
  "pos.ops.contextUpdated": "Mesa o mesero actualizado. Los datos originales se conservan en el historial.",
  "pos.ops.course": "Tiempo {course}",
  "pos.ops.kitchen": "Pantalla de cocina",
  "pos.ops.kitchenHint":
    "Comandas de esta estación. Los cambios se actualizan automáticamente.",
  "pos.ops.station": "Estación",
  "pos.ops.chooseStation": "Elija una estación",
  "pos.ops.noStations": "No hay estaciones de cocina configuradas",
  "pos.ops.noStationsHint":
    "Cree una estación en Dispositivos e impresión y elija los artículos que recibe.",
  "pos.ops.noTickets": "No hay comandas activas",
  "pos.ops.check": "Cuenta {number}",
  "pos.ops.table": "Mesa {table}",
  "pos.ops.seat": "Asiento {seat}",
  "pos.ops.void": "ANULADO",
  "pos.ops.queued": "En cola",
  "pos.ops.preparing": "En preparación",
  "pos.ops.ready": "Lista",
  "pos.ops.completed": "Completada",
  "pos.ops.cancelled": "Cancelada",
  "pos.ops.start": "Empezar preparación",
  "pos.ops.markReady": "Marcar lista",
  "pos.ops.complete": "Completar",
  "pos.ops.devices": "Dispositivos e impresión",
  "pos.ops.devicesHint":
    "Conecte un agente local de ClubCore, apruebe las impresoras detectadas y asígnelas a los puntos de venta y estaciones de cocina.",
  "pos.ops.agents": "Agentes de la red local",
  "pos.ops.agentName": "Nombre del agente",
  "pos.ops.enrol": "Crear credencial del agente",
  "pos.ops.tokenHint":
    "Copie esta credencial ahora. Solo se muestra una vez. Guárdela en el agente local, nunca en un terminal TPV.",
  "pos.ops.revoke": "Revocar agente",
  "pos.ops.revokeConfirm":
    "¿Revocar este agente? Sus impresoras dejarán de recibir trabajos hasta que se configure otro agente.",
  "pos.ops.noAgents":
    "No hay un agente local conectado. ClubCore alojado necesita un dispositivo siempre encendido en la red local para descubrir impresoras e imprimir automáticamente.",
  "pos.ops.lastSeen": "Última conexión",
  "pos.ops.never": "Nunca conectado",
  "pos.ops.stale": "Sin informes recientes",
  "pos.ops.online": "En línea",
  "pos.ops.offline": "Sin conexión",
  "pos.ops.revoked": "Revocado",
  "pos.ops.printers": "Impresoras detectadas",
  "pos.ops.deviceKey": "Clave local del dispositivo",
  "pos.ops.printersHint":
    "La detección no habilita la impresión. Apruebe una impresora y asígnela abajo. Las impresoras sin detección pueden configurarse en el agente.",
  "pos.ops.noPrinters": "Aún no se han detectado impresoras",
  "pos.ops.discoveryOnly": "Solo detección",
  "pos.ops.protocolHint":
    "Se admiten impresoras ESC/POS RAW 9100 y colas RAW de Windows. Los dispositivos IPP/LPD solo se muestran en el inventario.",
  "pos.ops.approve": "Aprobar impresora",
  "pos.ops.disable": "Deshabilitar impresora",
  "pos.ops.terminals": "Estado de los terminales",
  "pos.ops.noTerminals": "Ningún terminal ha enviado informes",
  "pos.ops.stations": "Estaciones y plantillas de cocina",
  "pos.ops.newStation": "Nueva estación",
  "pos.ops.editStation": "Editar estación",
  "pos.ops.name": "Nombre",
  "pos.ops.outlet": "Punto de venta",
  "pos.ops.active": "Activo",
  "pos.ops.printer": "Impresora",
  "pos.ops.noPrinter": "Sin impresión automática",
  "pos.ops.categories": "Categorías a enviar",
  "pos.ops.categoriesHint":
    "Sin selección se envían todas las categorías. Se siguen aplicando los tipos de artículo.",
  "pos.ops.itemTypes": "Tipos de artículo a enviar",
  "pos.ops.columns": "Columnas de cocina",
  "pos.ops.fontSize": "Tamaño del texto de cocina (px)",
  "pos.ops.warningMinutes": "Resaltar después de (minutos)",
  "pos.ops.showNotes": "Mostrar notas de cocina",
  "pos.ops.header": "Encabezado impreso",
  "pos.ops.footer": "Pie impreso",
  "pos.ops.paperWidth": "Ancho del papel",
  "pos.ops.paperMillimeters": "{width} mm",
  "pos.ops.showPrices": "Imprimir precios",
  "pos.ops.showSignature": "Imprimir línea de firma",
  "pos.ops.receipts": "Impresión de recibos por punto de venta",
  "pos.ops.receiptsHint":
    "El recibo se añade a la cola al liquidar la cuenta. Las comandas se añaden al enviar los artículos.",
  "pos.ops.jobs": "Cola de impresión",
  "pos.ops.noJobs": "No hay trabajos de impresión",
  "pos.ops.claimed": "Enviando",
  "pos.ops.printed": "Entregado a la impresora",
  "pos.ops.uncertain": "Revisar impresora",
  "pos.ops.retry": "Reimprimir tras comprobar",
  "pos.ops.resolvePrinted": "Confirmar que ya se imprimió",
  "pos.ops.resolveCancelled": "Cancelar este trabajo",
  "pos.ops.resolveHint":
    "Registre lo que encontró en la impresora. Se resolverá el trabajo sin volver a enviarlo.",
  "pos.ops.reason": "Motivo de la resolución",
  "pos.ops.retryConfirm":
    "Revise la impresora primero. Podría salir un duplicado si el trabajo original se imprimió sin confirmación. ¿Poner otro intento en cola?",
  "pos.ops.kind.kitchen": "Comanda de cocina",
  "pos.ops.kind.receipt": "Recibo",
  "pos.ops.kind.void": "Aviso de anulación",
  "pos.ops.saved": "Guardado",
  "pos.printers.search": "Buscar impresora",
  "pos.printers.group.production": "Impresoras de cocina y recibos",
  "pos.printers.group.office": "Impresoras de oficina y virtuales",
  "pos.printers.group.unclassified": "Sin clasificar",
  "pos.printers.emptyGroup": "No hay impresoras en este grupo.",
  "pos.printers.purpose": "Uso previsto",
  "pos.printers.purposeFor": "Uso previsto de {name}",
  "pos.printers.purpose.kitchen": "Comanda de cocina",
  "pos.printers.purpose.receipt": "Recibo del cliente",
  "pos.printers.purpose.kitchen_receipt": "Cocina y recibos",
  "pos.printers.purpose.office": "Oficina / documentos",
  "pos.printers.purpose.virtual": "Impresora virtual",
  "pos.printers.purpose.unclassified": "Sin clasificar",
  "pos.printers.protocol.windows": "Cola de Windows",
  "pos.printers.protocol.raw": "Impresora de red RAW",
  "pos.printers.protocol.inventory": "Conexión de inventario",
  "pos.printers.stale": "Estado desactualizado",
  "pos.printers.unreachable": "Sin conexión de red",
  "pos.printers.queueAttention": "La cola informa de un problema",
  "pos.printers.reachable": "Conexión de red disponible",
  "pos.printers.queueUnverified": "Cola lista · red sin verificar",
  "pos.printers.reportedAvailable": "Disponible según el agente",
  "pos.printers.suggested": "Sugerido por los datos del dispositivo",
  "pos.printers.assigned": "Uso asignado",
  "pos.printers.configured": "Aprobada para enrutamiento",
  "pos.printers.notApproved": "Sin aprobar",
  "pos.printers.outputBlocked": "Impresión física desactivada",
  "pos.printers.outputEnabled": "Impresión física activada",
  "pos.printers.held": "Retenido · impresión desactivada",
  "pos.printers.details": "Detalles de conexión",
  "pos.printers.driver": "Controlador",
  "pos.printers.queueStatus": "Estado de la cola de Windows",
  "pos.preview.title": "Vista previa de rutas de cocina",
  "pos.preview.hint": "Compruebe platos calientes y fríos, una bebida y un artículo de tienda de ejemplo. No se crean pedidos, comandas ni trabajos de impresión y no se contacta ninguna impresora.",
  "pos.preview.run": "Ver rutas · sin imprimir",
  "pos.preview.hot": "Plato caliente de ejemplo",
  "pos.preview.cold": "Plato frío de ejemplo",
  "pos.preview.drink": "Bebida de ejemplo",
  "pos.preview.retail": "Artículo de tienda de ejemplo",
  "pos.preview.missingCategories": "Cree las categorías de cocina Caliente y Frío antes de ejecutar esta vista previa.",
  "pos.preview.noJobs": "Solo vista previa · 0 trabajos de impresión",
  "pos.preview.noRoutes": "Ninguna ruta de cocina corresponde a este punto de venta.",
  "pos.preview.liveConfigured": "La salida física está configurada; esta vista previa no envía nada.",
  "pos.preview.unrouted": "Sin ruta a cocina: {lines}",
  "pos.preview.selectOutlet": "Seleccione un punto de venta",
  "pos.ops.originalCheck": "Cuenta original n.º {number}",
  "pos.ops.splitTicket": "Este ticket corresponde a varias cuentas. Vea el destino de cada artículo.",
  "pos.ops.ticketDetails": "Artículos y destinos de la comanda",
  "pos.ops.portionPlacement": "{quantity} → Cuenta n.º {number} · {table} · {server}",
  "pos.ops.portionVoid": "Cantidad anulada: {quantity}",
  "pos.ops.linePlacement": "Ahora cuenta n.º {number} · Mesa {table} · {server}",
};
